import { useApiMutation } from "./use-api-mutation";

type ResendReturnRequestEmailToMemberParams = {
  returnRequestId: string;
  logId: string;
  /** Must be the email of a member of the shop. */
  email: string;
};

/** Shop admin/owner route: shop members only, 5-minute cooldown enforced. */
export default function useResendReturnRequestEmailToMember(shopId: string) {
  return useApiMutation(
    "post",
    "/shops/{shopId}/return-requests/{returnRequestId}/logs/{logId}/resend-email",
    {
      // The dialog shows a translated message per error code instead.
      notify: { error: false },
      mapVariables: ({
        returnRequestId,
        logId,
        email,
      }: ResendReturnRequestEmailToMemberParams) => ({
        params: { path: { shopId, returnRequestId, logId } },
        body: { email },
      }),
    },
  );
}
